import { withInstall, withNoopInstall } from '@jdesign-vue/utils'
import Button from './src/button.vue'
import ButtonGroup from './src/button-group.vue'

export const JdButton = withInstall(Button, {
  ButtonGroup,
})
export const JdButtonGroup = withNoopInstall(ButtonGroup)
export default JdButton

export * from './src/button'
export * from './src/constants'
export type { ButtonInstance, ButtonGroupInstance } from './src/instance'
